import basicRepository from '../../lib/basicRepository';
import { restApi } from '../../services/api';
import { TeceoApiResponse } from '../../types/request.types';

export const eventRepository = (slug: string) => {
  const defaultRepository = basicRepository({
    path: 'events',
    id: slug,
    restApi,
  });

  return {
    ...defaultRepository,
    checkIfBrandAreInSameEvent: (
      brandId: string,
    ): Promise<TeceoApiResponse<{ storeAndBrandAreInSameEvent: boolean }>> =>
      restApi.get(`events/verify-team-and-brand/${brandId}`),
  };
};
